<template>
    <div class="keyword-info-container">
        <div class="keyword-location-container">
            <!-- Account Level -->
            <div v-if="accountLevel" class="parent-container">
                <EntityPill v-if="loading" :type="Improvement.LocationEntity.AccountLevel">
                    <Skeleton
                        width="6rem"
                        color="hsla(174, 100%, 22%, 0.2)"
                        shimmer-color="hsla(174, 100%, 22%, 0.06)"
                    />
                </EntityPill>
                <EntityPill
                    v-else
                    :type="Improvement.LocationEntity.AccountLevel"
                    content="Account Level"
                />
                <div class="arrow-container">
                    <SmallArrow />
                </div>
                <Spacer height="10px" />
            </div>

            <!-- Negative List -->
            <div v-if="negativeList" class="parent-container">
                <EntityPill v-if="loading" :type="Improvement.LocationEntity.NegativeList">
                    <Skeleton
                        width="6rem"
                        color="hsla(0, 100%, 58%, 0.2)"
                        shimmer-color="hsla(0, 100%, 58%, 0.06)"
                    />
                </EntityPill>
                <EntityPill
                    v-else
                    :type="Improvement.LocationEntity.NegativeList"
                    :content="negativeList"
                />
                <div class="arrow-container">
                    <SmallArrow />
                </div>
                <Spacer height="10px" />
            </div>

            <!-- Campaign -->
            <div v-if="campaignName" class="parent-container">
                <EntityPill v-if="loading" :type="Improvement.LocationEntity.Campaign">
                    <Skeleton
                        width="6rem"
                        color="hsla(214, 100%, 50%, 0.2)"
                        shimmer-color="hsla(214, 100%, 50%, 0.06)"
                    />
                </EntityPill>
                <EntityPill
                    v-else
                    :type="Improvement.LocationEntity.Campaign"
                    :content="campaignName"
                />
                <div class="arrow-container">
                    <SmallArrow />
                </div>
                <Spacer height="10px" />
            </div>

            <!-- Ad Group -->
            <div v-if="adGroupName" class="parent-container">
                <EntityPill v-if="loading" :type="Improvement.LocationEntity.AdGroup">
                    <Skeleton
                        width="6rem"
                        color="hsla(256, 100%, 61%, 0.2)"
                        shimmer-color="hsla(256, 100%, 61%, 0.06)"
                    />
                </EntityPill>
                <EntityPill
                    v-else
                    :type="Improvement.LocationEntity.AdGroup"
                    :content="adGroupName"
                />
                <div class="arrow-container">
                    <SmallArrow />
                </div>
                <Spacer height="10px" />
            </div>

            <!-- Keyword -->
            <EntityPill
                v-if="loading"
                :type="
                    negative
                        ? Improvement.LocationEntity.NegativeKeyword
                        : Improvement.LocationEntity.Keyword
                "
            >
                <Skeleton
                    width="6rem"
                    color="hsla(174, 100%, 22%, 0.2)"
                    shimmer-color="hsla(174, 100%, 22%, 0.06)"
                />
            </EntityPill>
            <EntityPill
                v-else
                :type="
                    negative
                        ? Improvement.LocationEntity.NegativeKeyword
                        : Improvement.LocationEntity.Keyword
                "
                :content="keyword"
            />
        </div>
        <div class="more-info-container" v-if="$slots['keyword-info']">
            <slot name="keyword-info" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { EntityPill, Spacer } from '@opteo/components-next'
import SmallArrow from './SmallArrow.vue'
import Skeleton from '@/components/util/Skeleton.vue'

import { Improvement } from '@opteo/types'

defineProps<{
    keyword: string
    accountLevel?: boolean
    adGroupName?: string
    campaignName?: string
    negativeList?: string
    negative?: boolean
    loading?: boolean
}>()
</script>

<style scoped lang="scss">
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.keyword-info-container {
    @include flex-center;
    @include container;
    flex-direction: column;
    min-width: 312px;
}

.keyword-location-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    @include pa-24;
}

.parent-container {
    position: relative;
}

.arrow-container {
    height: 20px;
    width: 20px;
    @include container;
    @include flex-center;
    border-radius: 100%;
    position: absolute;
    bottom: -5px;
    left: calc(50% - 10px);
    z-index: 2;
}

.more-info-container {
    width: 100%;
    @include ph-24;
    @include pt-16;
    padding-bottom: 1.125rem;
    border-top: 1px solid;
    @include opteo-border;
}

.more-info-container > div {
    @include flex-center;
    flex-direction: column;
}
</style>
